import { ArrowRight } from "lucide-react";
import { Chapter, Stagger, StaggerItem } from "@/components/Reveal";
import { useLang } from "@/i18n";

const Blog = () => {
  const { t } = useLang();
  const b = t.blog;

  return (
    <section id="blog" data-testid="blog-section" className="py-24 md:py-32 bg-[#0A0A0A] border-y border-white/10">
      <div className="container-x">
        <Chapter num="06" label={b.chapter} />

        <h2 className="font-display text-4xl md:text-5xl lg:text-7xl uppercase tracking-tight leading-[0.9]">
          {b.titleA} <span className="text-[#D91624]">{b.titleB}</span>
        </h2>
        <p className="mt-6 max-w-2xl text-base md:text-lg text-neutral-400 leading-relaxed">
          {b.intro}
        </p>

        <Stagger className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {b.posts.map((post) => (
            <StaggerItem key={post.id}>
              <article
                data-testid={`blog-card-${post.id}`}
                className="group h-full bg-[#0A0A0A] p-8 flex flex-col justify-between min-h-[220px] hover:bg-[#121212] transition-colors duration-500 cursor-pointer"
              >
                <div>
                  <p className="text-[10px] font-bold uppercase tracking-[0.25em] text-[#D4AF37]">
                    {post.cat}
                  </p>
                  <h3 className="mt-3 text-lg md:text-xl font-bold text-white leading-snug group-hover:text-[#D4AF37] transition-colors duration-300">
                    {post.title}
                  </h3>
                </div>
                <div className="mt-8 flex items-center justify-between text-xs uppercase tracking-[0.2em] text-neutral-600 font-bold">
                  <span>
                    {post.date} · {post.read}
                  </span>
                  <ArrowRight
                    size={16}
                    className="text-neutral-600 group-hover:text-[#D91624] group-hover:translate-x-1 transition-all duration-300"
                  />
                </div>
              </article>
            </StaggerItem>
          ))}
        </Stagger>
      </div>
    </section>
  );
};

export default Blog;
